import React, { useState } from 'react'
import { i18n } from '../i18n/i18n'

let openedByDefaultCount = 0

type PlanSlug = 'free' | 'starter' | 'advanced' | 'custom'

const ToggleContent: React.FC<{
    title: string
    slug: PlanSlug
}> = ({ title, slug }) => {
  const shouldOpenByDefault = openedByDefaultCount < 3
  const [isContentVisible, setContentVisible] = useState(() => {
    if (shouldOpenByDefault) {
      openedByDefaultCount++
      return true
    }
    return false
  })

  const toggleVisibility = () => {
    setContentVisible(!isContentVisible)
  }

  const featureKeyMap: Record<PlanSlug, string> = {
    free: 'Free_features',
    starter: 'Starter_features',
    advanced: 'Advanced_features',
    custom: 'Custom_features'
  }

  const features: string[] = i18n(featureKeyMap[slug]) as string[]

  return (
        <div>
            <div
                style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                onClick={toggleVisibility}
            >
        <span style={{ marginRight: 8 }}>
          {isContentVisible ? '▼' : '►'}
        </span>
                <span>{title}</span>
            </div>

            {isContentVisible && (
                <p className="subscription-description">
                    {features.map((item, index) => (
                        <React.Fragment key={index}>
                            <br/>- {item}
                        </React.Fragment>
                    ))}
                </p>
            )}
        </div>
  )
}

export default ToggleContent
